<template>
  <div class="wizard-step" :class="bemFacets">
    <slot name="outer" />
    <div class="wizard-step__scroll-container-wrap">
      <div class="wizard-step__scroll-container">
        <div class="layout layout--map-wizard">
          <div class="layout__container">
            <div class="wizard-step__title">
              <slot name="title">
                <h1>
                  {{ $t(wizardStep.label) }}
                </h1>
              </slot>
            </div>
            <div class="wizard-step__content">
              <slot name="default" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { interstitialContentList } from '@/assets/js/model/interstitial-content'
  import bemMixin from '@/assets/js/mixin/bem'
  import { personaIds } from '@/assets/js/model/persona'

  export default {
    mixins: [bemMixin('wizard-step')],
    props: {
      wizardStep: {
        type: Object,
        required: true,
      },
      prevRoute: {
        type: Object,
        default: null,
      },
      nextRoute: {
        type: Object,
        default: null,
      },
    },
    watch: {
      'wizardStep.id': {
        handler(step) {
          const interstitialContent = interstitialContentList.find(
            ({ personaId, wizardStepId }) => {
              return wizardStepId === step && personaId === personaIds.CUSTOM
            },
          )

          if (interstitialContent) {
            this.setInterstitial({
              isOpen: true,
              id: interstitialContent.id,
            })
          }
        },
        immediate: true,
      },
    },
    methods: {
      ...mapActions('interstitial', ['setInterstitial']),
    },
  }
</script>

<style lang="scss" src="./_wizard-step.scss" />
